import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { parseDateToStringWithFormat } from '../../utils/dateFormat';
import { Components } from './styled';
import { ReactComponent as ArrowLeftIcon } from '../../assets/icons/icon-arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/icon-angle-right.svg';
import { SessionContext } from '../../providers/SessionProvider/context';
import ProfileAvatar from '../ProfileAvatar';
import useDropdown from '../../hooks/useDropdown';
import ProjectDropdown from '../ProjectDropdown';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import ProjectSideBar from '../ProjectSideBar';

const ProjectHeaderBar = ({
  hasBack,
  title,
  secondaryTitle,
}: {
  hasBack?: boolean | string;
  title?: string;
  secondaryTitle?: string;
}) => {
  const navigate = useNavigate();
  const { currentProfile, logout } = useContext(SessionContext);

  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const profileMenuProps = useDropdown();
  const currentDayText = parseDateToStringWithFormat(new Date(), 'E, MMMM do') + ' UTC';
  const canClickTitle = secondaryTitle !== undefined && typeof hasBack === 'string' && hasBack?.length > 0;

  const onOpenMenu = () => {
    setIsDrawerOpen(true);
  };
  const onMenuClose = () => {
    setIsDrawerOpen(false);
  };

  const onBack = () => {
    navigate(-1);
  };

  const onTitlePress = () => {
    if (canClickTitle) {
      navigate(hasBack);
    }
  };

  return (
    <Components.Container>
      <Components.LeftSideWrapper>
        <SwipeableDrawer anchor={'left'} open={isDrawerOpen} onClose={onMenuClose} onOpen={onOpenMenu}>
          <ProjectSideBar />
        </SwipeableDrawer>

        {typeof hasBack === 'boolean' && hasBack && (
          <Components.BackButton onClick={onBack}>
            <Components.LeftSideIconWrapper>
              <ArrowLeftIcon />
            </Components.LeftSideIconWrapper>
            Back
          </Components.BackButton>
        )}
        {title && (
          <Components.LeftSideTitle onClick={onTitlePress} isClickable={canClickTitle}>
            {title}
          </Components.LeftSideTitle>
        )}
        {secondaryTitle && (
          <>
            <Components.LeftSideIconWrapper>{<ArrowRightIcon />}</Components.LeftSideIconWrapper>
            <Components.LeftSideTitle>{secondaryTitle}</Components.LeftSideTitle>
          </>
        )}
      </Components.LeftSideWrapper>
      <Components.RightSectionWrapper displayFlex flexDirection='row' alignItems='center' justifyContent={'center'}>
        <Components.ClockWrapper>
          <Components.ClockIcon />
          <Components.Clock format={'HH:mm A'} ticking />
        </Components.ClockWrapper>

        <Components.DateLabel>{currentDayText}</Components.DateLabel>
        <Components.Separator />
        <Components.ProfileWrapper onClick={(e) => profileMenuProps.show(e)}>
          <Components.ProfileLabel>{currentProfile?.fullName || 'Alux Admin'}</Components.ProfileLabel>
          <ProfileAvatar size={32} initials={currentProfile?.initials || 'AD'} />
        </Components.ProfileWrapper>
        <ProjectDropdown {...profileMenuProps} onLogout={logout} />
      </Components.RightSectionWrapper>
    </Components.Container>
  );
};

export default ProjectHeaderBar;
